// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"secondary-page-module--pageContainer--X3yl7","title":"secondary-page-module--title--3TvRL","body":"secondary-page-module--body--2tzN_"};